// we overall want the suggestions pane to be at least 260px wide (plus padding, which we will
// get from the theme).
export const MIN_SUGGESTIONS_PANE_WIDTH = 260;

// when the layout expands to multi-column, this is the minimum width of each column.
// this value ensures that the columns are never larger than 440px - the suggestions look
// weird if they get too wide.
export const MIN_MULTI_COLUMN_SIZE = 220;
